import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames'

const IconRevenuesSVG = ({color, className, ...rest}) => {
    return (
        <svg {...rest} width="20.002" height="20.002" viewBox="0 0 20.002 20.002" className={classNames(['svg-icon svg-revenues', className])}>
            <path className="svg-revenues_a" fill="none"
                  d="M0,0V20H20V0ZM.833,10.834v-5a2.5,2.5,0,0,1,2.5-2.5h10a2.5,2.5,0,0,1,2.5,2.5v5.834a1.672,1.672,0,0,1-1.667,1.667H3.334A2.5,2.5,0,0,1,.833,10.834ZM19.169,15A1.672,1.672,0,0,1,17.5,16.668H4.167a.833.833,0,0,1,0-1.667H17.5V6.667a.833.833,0,1,1,1.667,0Z"/>
            <path className="svg-revenues_b" fill={color}
                  d="M19.335,7.334v8.334a1.672,1.672,0,0,1-1.667,1.667H4.334a.833.833,0,1,1,0-1.667H17.668V7.334a.833.833,0,1,1,1.667,0ZM3.5,14A2.5,2.5,0,0,1,1,11.5v-5A2.5,2.5,0,0,1,3.5,4h10A2.5,2.5,0,0,1,16,6.5v5.834A1.672,1.672,0,0,1,14.335,14ZM6,9A2.5,2.5,0,1,0,8.5,6.5,2.5,2.5,0,0,0,6,9Z"
                  transform="translate(-0.167 -0.666)"/>
        </svg>
    );
};

IconRevenuesSVG.propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

IconRevenuesSVG.defaultProps = {
    color: '#fff',
    className: '',
};

export default IconRevenuesSVG;